@import '../../assets/styles/variables';
@import '../../assets/styles/typography';
@import '../../../node_modules/@cpt/pci/postnl-styles/settings';

:host(*) {
    all: initial;
    font-family: $font-family-bodytext, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: 'ss03' on, 'ss01' on;
    font-size: 16px;
    box-sizing: border-box !important;
}

h1 {
    color: $blue;
    font-weight: 400;
    font-size: 1.5em;
    line-height: 1.33;
    display: block;
    margin-top: 0.25em;

    @media (min-width: $bp-nav) {
        display: inline;
        vertical-align: super;
    }
}

.pci-button-container {
    display: flex;
    margin-top: 1.5em;
    justify-content: left;
}

.pci-button {
    width: 100%;
    min-width: 8em;
    height: 2.63em;
    border: none;
    display: flex;
    color: $color-white;
    cursor: pointer;
    font-weight: 700;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: inherit;
    align-items: center;
    font-family: $font-family-bodytext, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding: 0.5em 1.5em;
    justify-content: center;
    background-color: $color-background-button-primary-default;
    border-radius: 0.25em;
    box-shadow: none;

    @media (min-width: $bp-nav) {
        width: auto;
    }

    &:hover {
        text-decoration: underline;
        text-underline-offset: 0.15em;
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline-color: $color-border-focus-outline;
        outline-style: solid;
        outline-width: 2px;
        outline-offset: 1px;
    }

    &:active {
        background-color: $color-text-button-secondary-pressed;
        text-decoration: underline;
        text-underline-offset: 0.15em;
    }
}

.pci-button--secondary {
    color: $color-background-button-primary-default;
    background-color: $color-white;
    border: thin solid $color-background-button-primary-default;
    border-radius: 0.25em;
    box-shadow: none;

    &:hover {
        text-decoration: underline;
        text-underline-offset: 0.15em;
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline-color: $color-border-focus-outline;
        outline-style: solid;
        outline-width: 2px;
        outline-offset: 1px;
    }

    &:active {
        color: $color-text-button-secondary-pressed;
        background-color: $color-white;
        text-decoration: underline;
        text-underline-offset: 0.15em;
        border: thin solid $color-text-button-secondary-pressed;
        border-radius: 0.25em;
    }
}

.pci-button--tertiary {
    background-color: $color-white;
    border: none;
    color: $color-background-button-primary-default;

    &:active {
        background-color: #ffffff00;
        border-color: #ffffff00;
        color: $color-border-focus-outline;
    }

    &:hover {
        text-decoration: underline;
        text-underline-offset: 0.15em;
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline-color: $color-border-focus-outline;
        outline-style: solid;
        outline-width: 2px;
        outline-offset: 1px;
    }
}
